import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-display font-semibold">404</h1>
      <p className="text-muted-foreground">Ruta no encontrada.</p>
      <Button asChild variant="default">
        <Link to="/dashboard">Volver al dashboard</Link>
      </Button>
    </div>
  );
}
